import { CircularProgress } from "@/atoms";
import { strings } from "@/constants";
import { CodePageStatusEnum } from "@/enums";
import type { CodePageStatusType } from "@/types";

export const CodeTitle = ({
    errorMessage,
    progress,
    status,
}: {
    errorMessage: string,
    progress: number,
    status: CodePageStatusType,
}) => {
    if (status === CodePageStatusEnum.IDLE) {
        return (
            <h1
                className="
                    text-gradient
                    mb-8
                    text-2xl
                    font-bold
                    sm:text-3xl
                "
            >
                {strings.code.titleEnter}
                {" "}
                {strings.code.titleSuffix}
                .
            </h1>
        );
    }

    if (status === CodePageStatusEnum.LOADING) {
        return (
            <>
                <h1
                    className="
                        text-gradient
                        mb-6
                        text-2xl
                        font-bold
                        sm:text-3xl
                    "
                >
                    {strings.code.titleLoading}
                </h1>
                <div className="mb-8">
                    <CircularProgress progress={progress} />
                </div>
            </>
        );
    }

    if (status === CodePageStatusEnum.ERROR) {
        return (
            <>
                <h1
                    className="
                        text-gradient-error
                        mb-2
                        text-2xl
                        font-bold
                        italic
                        sm:text-3xl
                    "
                >
                    {errorMessage || strings.code.errorDefault}
                </h1>
                <span className="mb-8 block text-text-muted">{strings.code.errorSubtitle}</span>
            </>
        );
    }

    return null;
};
